import { useEffect, useState } from "react";
import { Dimensions } from "react-native";

export default function useSN() {
  const [W, setW] = useState(Dimensions.get("window").width);

  useEffect(() => {
    Dimensions.addEventListener("change", (e) => {
      setW(e.window.width);
    });
  }, []);

  function sn<T, U, K, X>(max_576: T, max_768?: U, max_992?: K, min_1200?: X) {
    return W < 576
      ? max_576
      : W < 768
      ? max_768 ?? max_576
      : W < 992
      ? max_992 ?? max_576
      : min_1200 ?? max_576;
  }

  return sn;
}
